<template>
    <div>
        <div id="footerarea"/>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                rl_footer_url:
                    window.rlServerURL.MainWeb +
                    "includes/nav/product-footer-en.html"
            };
        },
        mounted () {
            let vm = this;
            if ($("#footerarea").length > 0) {
                $("#footerarea").load(vm.rl_footer_url, function () {
                    $("<link>")
                        .appendTo("head")
                        .attr({ type: "text/css", rel: "stylesheet" })
                        .attr("href", window.rlServerURL.MainWeb + "/includes/css/product-footer-gray.css");
                    $("<link>")
                        .appendTo("head")
                        .attr({ type: "text/css", rel: "stylesheet" })
                        .attr("href", window.rlServerURL.MainWeb + "/includes/css/modules/top.css");
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/footer.vue